import { render, staticRenderFns } from "./PayPrice.vue?vue&type=template&id=f36f1300&"
import script from "./PayPrice.vue?vue&type=script&lang=js&"
export * from "./PayPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports